<template>
    <div>
        <!-- Coparticipação -->
        <div class="modal fade" id="infoCoparticModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="exibir">
                    <div class="modal-header">
                        <h5 class="modal-title">Coparticipação</h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input 
                            label="Valor" 
                            type="money" 
                            v-model="valor" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="confirmar()">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    components: { 
        AzInput 
    },

    data() {
        return { 
            valor: 0,
            exibir: false
        }
    },

    methods: { 
        abrir () { 
            this.exibir = false;
            this.valor = 0;

            this.$nextTick(() => { 
                this.exibir = true;
                $('#infoCoparticModal').modal('show');
            });
        },

        confirmar() { 
            if ( !this.valor ) { 
                if ( !confirm('Confirma não informar valor de coparticipação?') ) { 
                    return;
                }
            }

            this.$emit('confirmar', this.valor);
            this.fechar();
        },

        fechar() { 
            $('#infoCoparticModal').modal('hide');
        }
    }
}
</script>
